import { LetterbooksCharacterConditionType } from "features/Letterbooks/types";
import { LetterbooksParentCharacterContextType } from "types/LetterbooksParentContextType";

export default function libraryConditions(
  context: LetterbooksParentCharacterContextType
): LetterbooksCharacterConditionType {
  const { character } = context;

  return {
    character_id: character.id,
  };
}
